import * as React from 'react';

import { Container, Spinner } from './loadingSpinner.styled';
import { LoadingSpinnerProps } from './loadingSpinner.types';

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = (props: LoadingSpinnerProps): JSX.Element => {
  const { className }: LoadingSpinnerProps = props;

  return (
    <Container className={className}>
      <Spinner />
    </Container>
  );
};
